import React, { useEffect, useState } from "react";
import { DataTable } from "../../CommonComponent";
import './savepartlist.scss'
import { Iprops } from "./savepartlistinterface";
import { XLsvg } from "../../../assets/images/index"
import { useSelector } from "react-redux";
import { selectors as headerSelector } from "../../../state/features/header";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import helperfunctions from "../../../utils/helperfunctions";
import partsService from "../../../services/partsservice";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import Alerts from "../../Alerts";
import { Checkbox } from "@progress/kendo-react-inputs";
import { confirmDailog } from "../../ConfirmDailog";
import Loader from "../../Loader";

const DetailComponentCell = (props: any) => {
    const { headercurrentuser: { azureADId } }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    let ref = props?.gridRef?.current;
    const [isChildEvent, setIsChildEvent] = useState<any>(false);
    const [selectedBookmarkItem, setSelectedBookmarkItem] = useState<any>([]);
    const [bookmarkItems, setBookmarkItems] = useState<any>([]);

    useEffect(() => {
        if (bookmarkItems.length == 0) {
            const model = {
                userAadId: azureADId,
                shopListId: props.row.dataItem.partsListID,
                distributorCode: globalData?.DistributorCode,
                customerId: globalData?.CustomerId
            }

            partsService.getSavedPartListDetails(model)
                .then((response: any) => {
                    let data = response ?? [];
                    setBookmarkItems(data);
                    let selecteItem = props.row.dataItem.checked ? data : [];
                    setSelectedBookmarkItem(selecteItem);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                });
        }
    }, [])

    useEffect(() => {
        if (!isChildEvent) {
            if (props.row.dataItem.checked) {
                setSelectedBookmarkItem(bookmarkItems);
            }
            else {
                setSelectedBookmarkItem([]);
            }
        }
        else {
            setIsChildEvent(false);
        }
    }, [props.row.dataItem.checked])

    const onSelectionChange = (event: any, dataItem: any) => {
        event.field = 'checked';
        event.dataItem = props.row.dataItem;
        if (event.target.value) {
            const list = [...selectedBookmarkItem, dataItem];
            setSelectedBookmarkItem(list);
            if (list?.length == bookmarkItems.length) {
                event.value = true;
                setIsChildEvent(true);
                ref.itemChange(event);
            }
        }
        else {
            if (selectedBookmarkItem.length == bookmarkItems.length) {
                setIsChildEvent(true);
                event.value = false;
                ref.itemChange(event);
            }
            setSelectedBookmarkItem((current: any) =>
                current.filter((t: any) => {
                    return t.partNumber !== dataItem.partNumber;
                }),
            );
        }
    }

    return (
        <DetailComponentDetail selectedBookmarkItem={selectedBookmarkItem} bookmarkItems={bookmarkItems} onSelectionChange={onSelectionChange} setBookmarkItems={setBookmarkItems} addToCartConfirm={props.addToCartConfirm} />
    )
}

const ActionCheckBoxComponent = (props: any) => {
    const partNumber = props.dataItem.partNumber;
    return (
        <td>
            <Checkbox value={(props.selectedBookmarkItem?.filter((s: any) => s.partNumber == partNumber)?.length) > 0} onChange={(event: any) => props.onSelectionChange(event, props.dataItem)}></Checkbox>
        </td>
    )
}

const QuantitySavePartListColumn = (props: any) => {
    const { t } = useTranslation();
    let [childCount, setChildCount] = useState(props.dataItem.quantity);
    function onChange(e: any, value: any) {
        const updatedItems = props.bookmarkItems.map((t: any) => {
            if (t.partNumber == props.dataItem.partNumber) {
                t.quantity = value;
            }
            return t;
        })
        props.setBookmarkItems(updatedItems);

    }
    function incrementChildCount(e: any) {
        let cnt = childCount + 1;
        if (cnt <= 9999) {
            setChildCount(cnt);
            onChange(e, cnt);
        }
    }
    function decrementChildCount(e: any) {
        if (childCount === 1) {
            setChildCount(1);
        } else {
            let cnt = childCount - 1;
            setChildCount(cnt);
            onChange(e, cnt);
        }
    }

    const handleQntChildChange = (event: any) => {
        const value = parseInt(event.target.value);
        if (value <= 0) {
            setChildCount(1);
        }
        else if (value > 9999) {
            setChildCount(9999);
        }
        else {
            setChildCount(isNaN(value) ? 1 : value);
        }
    }

    const handleOnBlur = (event: any) => {
        const value = parseInt(event.target.value);
        onChange(event, value);
    }

    return (
        <td>
            <div className="quantity-value">
                <span onClick={(e: any) => decrementChildCount(e)} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Partlist_Decrease)} className="quantity_minus">-</span>
                <span><input type="text" className="textfieldsub" onChange={handleQntChildChange} onBlur={handleOnBlur} value={childCount}></input></span>
                <span onClick={(e: any) => incrementChildCount(e)} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Partlist_Increase)} className="quantity_plus">+</span>
            </div>
        </td>
    )
};

const DetailComponentDetail = (props: any) => {
    const { selectedBookmarkItem, bookmarkItems, onSelectionChange, setBookmarkItems, addToCartConfirm } = props;
    const { t } = useTranslation();

    const subColumns = [
        {
            field: 'action',
            title: '',
            width: 40,
            cell: (row: any) => ActionCheckBoxComponent({ selectedBookmarkItem: selectedBookmarkItem, dataItem: row.dataItem, onSelectionChange: onSelectionChange }),
            style: { textAlign: 'center' },
            sortable: false,
            filterable: false,
            editable: true
        },
        {
            field: 'manufacturerName',
            title: t(RESOURCE.MyK_Label_ManufacturerName),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 180,
            editable: false
        },
        {
            field: "partNumber",
            title: t(RESOURCE.MyK_Grid_Part_Number),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 180,
            editable: false
        },
        {
            field: 'description',
            title: t(RESOURCE.MyK_Grid_Description),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 220,
            editable: false
        },
        {
            field: 'quantity',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quantity),
            cell: (row: any) => QuantitySavePartListColumn({ dataItem: row.dataItem, bookmarkItems: bookmarkItems, setBookmarkItems: setBookmarkItems }),
            style: { textAlign: 'center' },
            sortable: true,
            width: 140,
            filterable: false,
            headerClassName: 'quantityHeaderColumn',
            editable: false
        },
        {
            field: 'machine',
            title: t(RESOURCE.MyK_Grid_Machine),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 240,
            editable: false
        }
    ]

    return (
        <>
            <div className="nestedparent_grid">
                <DataTable
                storageKey={"savedPartListDetail"} enableFiltering={true}
                    data={bookmarkItems}
                    dataColumn={subColumns}
                    reorderable={true}
                    onItemChange={null}
                />
                <div className="addtocartbtn mt-2">
                    <button disabled={selectedBookmarkItem?.length <= 0} className={"addtocart " + (selectedBookmarkItem?.length > 0 ? "" : "disabled")} onClick={() => addToCartConfirm(selectedBookmarkItem)}>{t(RESOURCE.MyK_Label_AddToCart)}</button>
                </div>
            </div>
        </>
    )
}

const SavePartList = (props: Iprops) => {

    const gridRefSavepartList = React.createRef<any>();
    const { onRefresh } = props;
    const { t } = useTranslation();
    const { headercurrentuser: { azureADId } }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: headerSelector.imgbaseUrl(state),
    }));
    const imgUrl = imgBaseUrlSelectors;
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<string>("");
    const [isAddingParts, setIsAddingParts] = useState(false)

    const showErrorMessage = (message: any) => {
        setErrorSuccessMessage(message);
        setShowAlert(true);
    }

    const handleErrorClose = () => {
        setErrorSuccessMessage('');
        setShowAlert(false);
    };

    const addToList = () => {
        if (props?.selectedBookmarkItem?.length > 0) {
            props.addtoListOnClick();
        }
        else {
            showErrorMessage(t(RESOURCE.MyK_Label_SC_Add_PartList_Validation_OnePart));
        }
    } 

    const addToCartConfirm = (selectedBookmarkItem: any) => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_SC_AddList_To_SC_Confirm),
            message: t(RESOURCE.MyK_Label_SC_AddList_To_SC_Confirm_Msg),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                addToCart(selectedBookmarkItem);
            },
            noOnclick: () => {
            },
        }

        confirmDailog(confimObject);
    }

    const addToCart = (selectedBookmarkItem :any) => {
        const partsModel = selectedBookmarkItem?.map((part: any) => {
            return {
                manufacturer: {
                    code: part?.manufacturerCode,
                    name: part?.manufacturerName
                },
                partNumber: part?.partNumber,
                quantity: part?.quantity,
                machine: {
                    mDbId: 0
                }
            }
        })
        let isPartNoNotValid = partsModel?.filter((s: any) => s.partNumber == null || s.partNumber == "" || s.partNumber?.toLowerCase() == "select")?.length > 0;
        let isQuantityNotValid = partsModel?.filter((s: any) => s.quantity < 0 || s.quantity > 9999)?.length > 0;
        let isManufactureNotValid = partsModel?.filter((s: any) => (s.manufacturer?.code == "" || s.manufacturer?.code == null || s.manufacturer?.name == "" || s.manufacturer?.name == null))?.length > 0;

        if (isPartNoNotValid) {
            helperfunctions.showErrorMessageTop(t(RESOURCE.MyK_Label_ShoppingCart_Part_Number_Required));
        }
        else if (isManufactureNotValid) {
            helperfunctions.showErrorMessageTop(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
        }
        else if (isQuantityNotValid) {
            helperfunctions.showErrorMessageTop(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
        }
        else {
            addPartNumber(partsModel);
        }
    }

    const addPartNumber = (parts: any) => {
        setIsAddingParts(true);
        const model = {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0
            },
            parts: parts
        };

        partsService.addPartNumber(model)
            .then((response: any) => {
                setIsAddingParts(false)
                if (response.isSuccessful) {
                    props?.getMiningParts();
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                    onRefresh(null, true);
                }
                else {
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
                }
            })
            .catch((e: any) => {
                setIsAddingParts(false)
                helperfunctions.showErrorMessage(e);
            });
    }

    const DetailComponent = React.useMemo(() => (props: any) => DetailComponentCell({ ...props, addToCartConfirm: addToCartConfirm }), [])

    return (
        <div className="partsList_Wrapper">
            {(props?.isFetchingPartsListItems || isAddingParts) && <Loader/>}
                    <div className="bookmarked_header">
                        <span>{t(RESOURCE.MyK_Label_ShoppingCart_Bookmarked_Parts)}</span>
                    </div>
                    <div className="row mb-4 mt-4">
                    <div className="col-12">
                        {showAlert && (
                            <Alerts
                                messageAlert={errorSuccessMessage}
                                alertType={'error'}
                                time={3000} onClose={() => handleErrorClose()}
                            />
                        )}
                            <div className="addlist_wrapper">
                                <button className="addtolistbtn" title={t(RESOURCE.MyK_Label_ShoppingCart_Add_To_List)} onClick={addToList}>
                                    {t(RESOURCE.MyK_Label_ShoppingCart_Add_To_List)}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 uploadpartslistpopup">
                        <DataTable
                        storageKey={"savedPartList"} enableFiltering={true}
                        data={props?.bookmarkItems}
                        dataColumn={props.columns}
                        reorderable={true}
                        rowReOrder={true}
                            />
                        </div>
                    </div>
            <div className="uploadpartlist_select mb-2">
                <span className="mb-1 mr-2">
                    <label><input disabled={props?.isFetchingPartsListItems} type="checkbox" id="uploadpersonalpartslist" onChange={(e: any) => props?.setIsCustomer(e.target.checked)} checked={props?.isCustomerSelected} className="uploadpartlistcheck mr-2" name="savecart"></input><span className="uploadpartslistlabel">{t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_List_Customer)}</span></label>
                </span>
                <span>
                    <label><input disabled={props?.isFetchingPartsListItems}  type="checkbox" id="sharedpartslist" onChange={(e: any) => props?.setIsUser(e.target.checked)} checked={props?.isUserSelected} className="uploadpartlistcheck mr-2" name="savecart"></input><span className="uploadpartslistlabel">{t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_List_User)}</span></label>
                </span>
            </div>
            <div className="nestedDatatable mt-3">
                <div className="bookmarked_header clearfix">
                    <div className="exportExecl" onClick={props.exportToExcel} onKeyDown={() => { }}><span><img src={imgUrl + XLsvg} className="mr-2"/></span>{t(RESOURCE.MyK_Label_ExportToExcel)}</div>
                </div>
                <div className="row">
                    <div className="col-12 SavePartsListTableTwo">
                        <DataTable
                        storageKey={"savedPartListNested"} enableFiltering={true}
                            firstPage={true}
                            gridRef={gridRefSavepartList}
                            data={props?.partsListItemsGrid}
                            dataColumn={props.nestedColumns}
                            isExpandWithItemChange={true}
                            reorderable={true}
                            DetailRow={true}
                            DetailComponent={(row: any) => DetailComponent({ row: row, gridRef: gridRefSavepartList })}
                            dataItemKey='partsListID'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SavePartList;
